import { BUILTIN_VIEWS, type CostChart, type CostQuery, type CostView } from './model';

const KEY = 'nexus-ui.costs.views';
const LAST_KEY = 'nexus-ui.costs.last';

export const readSavedViews = (): CostView[] => {
  try {
    const raw = globalThis.localStorage?.getItem(KEY);
    return raw ? (JSON.parse(raw) as CostView[]) : [];
  } catch {
    return [];
  }
};

export const writeSavedViews = (views: CostView[]) => {
  try {
    globalThis.localStorage?.setItem(KEY, JSON.stringify(views));
  } catch {
    // storage unavailable
  }
};

export const readLast = (): { query: CostQuery; chart: CostChart } | null => {
  try {
    const raw = globalThis.localStorage?.getItem(LAST_KEY);
    return raw ? (JSON.parse(raw) as { query: CostQuery; chart: CostChart }) : null;
  } catch {
    return null;
  }
};

export const writeLast = (state: { query: CostQuery; chart: CostChart }) => {
  try {
    globalThis.localStorage?.setItem(LAST_KEY, JSON.stringify(state));
  } catch {
    // storage unavailable
  }
};

export const allViews = (): CostView[] => [...BUILTIN_VIEWS, ...readSavedViews()];
